(function () {
  'use strict';
  if (window.__clnfLoginNudgeBound) return;
  window.__clnfLoginNudgeBound = true;

  var pageType = '';

  // Analytics fan-out. We do not know for certain which sink is live on any
  // given page (GTM container vs. Shopify web pixel), so emit to both and let
  // whichever is listening pick it up. Both calls are no-ops when absent.
  function emit(eventName, payload) {
    var data = payload || {};
    data.nudge_variant = 'sheet';
    data.nudge_page_type = pageType;
    try {
      window.dataLayer = window.dataLayer || [];
      var dlEvent = { event: eventName };
      for (var k in data) {
        if (Object.prototype.hasOwnProperty.call(data, k)) dlEvent[k] = data[k];
      }
      window.dataLayer.push(dlEvent);
    } catch (e) {}
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        // publish() returns a Promise. shopify.dev requires a .catch() so an
        // undelivered event never surfaces as an unhandled rejection.
        var published = window.Shopify.analytics.publish(eventName, data);
        if (published && typeof published.catch === 'function') {
          published.catch(function () {});
        }
      }
    } catch (e) {}
  }

  function initLoginNudge() {
    if (window.__CLNF_SLOW_CONNECTION) return;

    var STORAGE_KEY = 'clnf-login-nudge-dismissed';
    var CLICK_KEY = 'clnf-login-nudge-clicked';
    var DISMISS_MS = 14 * 24 * 60 * 60 * 1000;
    var DELAY_MS = 8000;
    var SCROLL_PX = 80;

    var root = document.getElementById('clnf-login-nudge-sheet');
    if (!root) return;

    pageType = root.getAttribute('data-clnf-nudge-template') || '';

    function isDismissed() {
      try {
        var raw = window.localStorage.getItem(STORAGE_KEY);
        if (!raw) return false;
        var ts = parseInt(raw, 10);
        if (!ts || Date.now() - ts > DISMISS_MS) {
          window.localStorage.removeItem(STORAGE_KEY);
          return false;
        }
        return true;
      } catch (e) {
        return false;
      }
    }

    if (isDismissed()) return;

    var shown = false;
    var delayTimer;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    var impressionSent = false;

    function show() {
      if (shown) return;
      shown = true;
      if (delayTimer) window.clearTimeout(delayTimer);
      root.setAttribute('aria-hidden', 'false');
      if (!impressionSent) {
        impressionSent = true;
        emit('clnf_login_nudge_shown', {});
      }
      if (prefersReducedMotion()) {
        root.classList.add('is-visible');
        return;
      }
      window.requestAnimationFrame(function () {
        root.classList.add('is-visible');
      });
    }

    function dismiss(method) {
      var wasVisible = impressionSent;
      shown = true;
      if (delayTimer) window.clearTimeout(delayTimer);
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
      try {
        window.localStorage.setItem(STORAGE_KEY, String(Date.now()));
      } catch (e) {}
      if (wasVisible) {
        emit('clnf_login_nudge_dismissed', { nudge_method: method || 'unknown' });
      }
    }

    root.addEventListener('click', function (e) {
      var dismissBtn = e.target.closest('[data-clnf-login-nudge-dismiss]');
      if (dismissBtn) {
        e.preventDefault();
        dismiss(dismissBtn.getAttribute('data-clnf-login-nudge-dismiss') || 'unknown');
        return;
      }

      var cta = e.target.closest('[data-clnf-login-nudge-cta]');
      if (!cta) return;
      var action = cta.getAttribute('data-clnf-login-nudge-cta');
      // Breadcrumb so a completed login on the return trip can be attributed
      // back to this nudge (see clnf-login-nudge-attribution.liquid).
      try {
        window.localStorage.setItem(CLICK_KEY, String(Date.now()));
      } catch (err) {}
      emit('clnf_login_nudge_clicked', { nudge_action: action });
    });

    delayTimer = window.setTimeout(show, DELAY_MS);

    if (window.scrollY > SCROLL_PX) {
      show();
      return;
    }

    window.addEventListener(
      'scroll',
      function onScroll() {
        if (window.scrollY > SCROLL_PX) {
          window.removeEventListener('scroll', onScroll);
          show();
        }
      },
      { passive: true }
    );
  }

  if (window.loadScheduler && typeof window.loadScheduler.onInteraction === 'function') {
    window.loadScheduler.onInteraction(function () {
      initLoginNudge();
    });
  } else {
    initLoginNudge();
  }
})();
